import React from 'react';
import { createPortal } from 'react-dom';
import Spinner from '../Spinner/spinner'; // Update the path to match the Spinner component's location in your project
import './SpinnerOverlay.css'; // Create a separate css file for this
import { useLanguage } from '../../i18n/LanguageContext';

const SpinnerOverlay = ({ creatingAd, loadingValuation }) => {
  const { t } = useLanguage();

  // Render overlay at root level to ensure it covers all UI including header
  return createPortal(
    <div className='spinner-overlay'>
      <div className="spinner-content">
        <Spinner />
        {creatingAd && (
          <div className="creating-ad-text">
            {t('smallWidgets.creatingAd')}<span className="dot-animation">...</span>
          </div>
        )}
        {loadingValuation && (
          <div className="creating-ad-text">
            {t('smallWidgets.loadingValuation')}<span className="dot-animation">...</span>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default SpinnerOverlay;
